/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';

import RightSideNav from '../../molecules/RightSideNav/RightSideNav';
import RightSideViewHomeSu from '../../molecules/RightSideViewHomeSu/RightSideViewHomeSu';
import { EStyleObj } from '../../../types';
import SidebarContext from '~src/contexts/SidebarContext';
import { useContext } from 'react';
import {
  MINIMIZED_RIGHT_BLOCK_WIDTH_CSS,
  RIGHT_BLOCK_WIDTH_CSS,
} from '~src/styles/constants';

const RightDisplaySuHome = () => {
  const { isSidebarMinimized } = useContext(SidebarContext);

  const style: EStyleObj = {
    // border: '1px red solid',
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'strech',
    width: isSidebarMinimized
      ? MINIMIZED_RIGHT_BLOCK_WIDTH_CSS
      : RIGHT_BLOCK_WIDTH_CSS,
    height: '100%',
  };

  return (
    <div css={style}>
      <RightSideNav />
      <RightSideViewHomeSu />
    </div>
  );
};

export default RightDisplaySuHome;
